import React from 'react';
import { AdminLayout } from '../../layouts/AdminLayout';
import styles from './ProfilePage.module.css';

export const ProfilePage: React.FC = () => {
  return (
    <AdminLayout>
      <div className={styles.container}>
        <h1 className={styles.title}>Profile</h1>
        <p className={styles.placeholder}>
          Profile management interface coming soon...
        </p>
      </div>
    </AdminLayout>
  );
};
